import { type AllSkillLevels } from "#constants/skillLevelConstants"
import {
  type ProjectConstructor,
  type ProjectForTable,
} from "#customTypes/composedTypes/projectTypes"
import { type Uuid } from "#customTypes/globalTypes"
import { semesterLookup } from "#forms/SemesterDropdown"

export class Project {
  id: Uuid
  name: string
  semester: string
  daysToComplete: string
  medium: string
  link: string
  skillLevels: AllSkillLevels[]
  notes: string
  description: string

  constructor({
    name,
    semester,
    daysToComplete,
    medium,
    link,
    skillLevels,
    notes,
    description,
    id,
  }: ProjectConstructor) {
    this.id = id
    this.name = name
    this.semester = semester
    this.daysToComplete = daysToComplete
    this.medium = medium
    this.link = link
    this.skillLevels = skillLevels
    this.notes = notes
    this.description = description
  }

  getName = (): string => this.name

  getProjectId = (): string | undefined => this.id

  getProjectForTable = (): ProjectForTable => ({
    id: this.id,
    name: this.name,
    semester: semesterLookup(this.semester),
    daysToComplete: this.daysToComplete,
    medium: this.medium,
    link: this.link,
    skillLevels: this.skillLevels?.join(", "),
    notes: this.notes?.substring(0, 40),
    description: this.description?.substring(0, 40),
  })
}
